import React, { useEffect, useState } from "react";
import ProductDetailImageEnlarge from "./ProductDetailImageEnlarge";
import Modal3D from "../../../../component/Product/3DModal";
import UltraLibrarianModal from "../../../../component/Product/UltraLibrarianModal";
import CartCommon from 'src/component/Global/Cart/Common';
import ProductCompareSelection from "../../../../component/Product/ProductCompareSelection";
// import { useSearchParams } from "react-router-dom";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import DisplayLifeCycleRisk from "src/component/Product/DisplayLifeCycleRisk";
import { isArray, isEqual } from "underscore";
import { useProductStore } from "src/hooks/product";
import ShowMoreLess from "../../../../component/Product/ShowMoreLess";
import ProductLegends from "src/pages/ProductListing/ProductLegends";
import System from "src/helper/system";
import DesignHubModalPopUp from "src/pages/DesignHubModalPopUp";
import Helper from "../../../../support/Helper";
import ProductPricingRepository from "src/repository/ProductPricingRepository";
import { useProductPricingStore } from "src/hooks/productPricing";
import { useProductInventoryStore } from "src/hooks/productInventory";
import { __remove } from "src/store/axios_indicator";
import Constants from "src/support/Constants";
import { useSelector } from "react-redux";
import useCheckAuthPermissions from "src/hooks/component/useCheckAuthPermissions";

const TopProductDetail = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [_check_p] = useCheckAuthPermissions();
  const [
    { productDetail, designHubData },
    { fetch_product_images_list, fetch_alternative_product_count, fetch_product_document_count, get_all_design_data, check_designs_exist },
    { },
  ] = useProductStore();
  const [isDesignAvailable, setIsDesignAvailable] = useState(false);
  const [designIdsArray, setDesignIdsArray] = useState([]);
  const [designData, setDesignData] = useState();
  const [showDesignHubModal, setShowDesignHubModal] = useState(false);
  const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
  const [{ }, { fetch_product_inventory_list }, { }] = useProductInventoryStore();
  // const inventory = inventoryList
  const [{ }, { fetch_product_pricing_list }, { }] = useProductPricingStore();
  const compareProductList = useSelector((state) => state.entities.model_ProductCompare.data, isEqual);

  let c = System.getParams();

  const speedBoatName =
    System.auth("speedBoat") === "T" ? "abacus" : System.auth("speedBoat") === "B" ? "ebv" : "silica";

  useEffect(() => {
    checkIfDesignsAvailable();
  }, [designHubData?.availableDesigns]);

  const fetchDesignData = async () => {
    if (isDesignAvailable && designIdsArray.length > 0) {
      const params = {
        itemNumberArray: designIdsArray,
        speedBoat: System.auth("speedBoat"),
      };

      const results = await get_all_design_data(params);
      if (results && Object.keys(results?.payload).length > 0) {
        setDesignData(results?.payload?.data);
      }
    }
  };

  const checkIfDesignsAvailable = async () => {
    designHubData?.availableDesigns.filter(v => {
      if (v.itemNumber === productDetail.value.ItemNumber && v.isDesignsAvailable) {
        setIsDesignAvailable(true);
        setDesignIdsArray(v?.designIds);
      } else {
        setIsDesignAvailable(false);
      }
    }
    );
  };

  useEffect(() => {
    async function fetchHere() {
      if (!monitorFunctionCall) {
        Helper.monitorJSDx();
        try {
          if (typeof avnetAnalytics === 'object') {
            avnetAnalytics?.init();
            console.log("FSP avnetAnalytics.init()")
          }
        } catch (error) {
          console.log("FSP avnetAnalytics.init() fail")
        }

        setMonitorFunctionCall(true)
      }
      if (productDetail && productDetail.value) {
        await fetchInventoryFromServer();
        await checkDesignsFromServer();
        await getImageData();
        await getAlternativeProductCountByVariantNumber();
        await getProductDocumentCount();
      }
      __remove('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')
    }

    fetchHere();
  }, [productDetail]);

  const checkDesignsFromServer = async () => {
    if (productDetail?.value) {
      let itemNumbers = [];
      itemNumbers.push(productDetail.value.ItemNumber)

      await check_designs_exist({ itemNumber: itemNumbers });
    }
  };

  const isGuestFullRights = () => {
    return (_check_p('PDG_ADD_TO_CART').status === true &&
      _check_p('PDG_ADD_TO_BOM').status === true &&
      _check_p('PDG_CLICK_TO_QUOTE').status === true ? true : false);
  }

  const fetchInventoryFromServer = async () => {
    if (productDetail && productDetail.value) {
      let params = !productDetail.value.ERPPartNumberModified && [{
        sboat: productDetail.value.Sboat,
        ERPManufacturerCode: productDetail.value.ERPManufacturerCode,
        ERPPartNumber: productDetail.value.ERPPartNumber
      }] || [];

      if (productDetail?.value?.TopProducts?.length > 0) {
        productDetail?.value?.TopProducts.forEach(topProduct => {
          let topProductObject = {
            sboat: productDetail.value.Sboat,
            // adding PDP MFRCode, because we are displaying top products from same MFR
            ERPManufacturerCode: productDetail.value.ERPManufacturerCode,
            ERPPartNumber: topProduct.ERPPartNumber
          }
          params.push(topProductObject)
        });
      }

      await Promise.all([
        params.length > 0 && fetch_product_inventory_list(params),
        fetchPricingFromServer()
      ]).then((resp) => {
      }).catch(() => { });
    }
  };


  const fetchPricingFromServer = async () => {
    if (productDetail && productDetail.value) {
      let params = [];
      let v = productDetail.value;

      let _isManual = true;
      if (Helper.valueIsNotNull(c.searchTerm))
        _isManual = CartCommon.isCpnIsManual(v, c.searchTerm);

      params.push({
        partNumber: v?.ERPPartNumberModified ? '' : v.ERPPartNumber,
        erpManufacturerCode: v.ERPManufacturerCode,
        erpMfrPartNumber: v.ERPMFRPartNumber,
        WebCode: v.WebCode,
        ObsoleteFlag: v.ObsoleteFlag,
        customerPartNumber: !_isManual ? Helper.toUpperCase(c.searchTerm) : undefined // 14790
      })

      if (isGuestFullRights()) {
        let paramSet = await new ProductPricingRepository().getPricingParams(params);
        await fetch_product_pricing_list(paramSet)
      }

    }
  };

  const getImageData = async () => {
    if (productDetail.value.ItemNumber) {
      let ItemNumber = productDetail.value.ItemNumber;
      let params = {};
      params.filter = "ItemNum  eq " + "'" + ItemNumber + "'";
      params.top = 100;
      params.variantAssetSearchType = "PDP";
      await fetch_product_images_list(params);
    }
  };

  const getAlternativeProductCountByVariantNumber = async () => {
    if (productDetail.value.ItemNumber) {
      await fetch_alternative_product_count({
        ItemNum: productDetail.value.ItemNumber,
      });
    }
  };

  const getProductDocumentCount = async () => {
    if (productDetail.value.ItemNumber) {
      let ItemNumber = productDetail.value.ItemNumber;
      await fetch_product_document_count({
        filter: "ItemNum  eq " + "'" + ItemNumber + "'",
      });
    }
  };

  const checkProductTitleMatch = (product) => {
    if (product?.value?.VendorPartNumber && product?.value?.ERPMFRPartNumber) {
      return product.value.ERPMFRPartNumber == product.value.VendorPartNumber;
    }
    return false;
  };

  const showDownloadMessage = () => {
    System.alert(Constants.downloadMsg, 'success')
  }

  return (
    <>
      {productDetail.value && (
        <>
          <h3 className="mt-0 mb-3 mob-font-13">
            {productDetail.value?.ERPMFRPartNumber && productDetail.value.ERPMFRPartNumber.trim() !== ""
              ? productDetail.value.ERPMFRPartNumber : ""}
          </h3>
          <ShowMoreLess single_product={productDetail.value} />

          <div className="product-detail-info">
            <div className="bs5 row flex-xl-nowrap">
              <ProductDetailImageEnlarge eRPMFRPartNumber = {productDetail.value.ERPMFRPartNumber}/>
              <div className="col-xl-7 col-lg-6 col-md-6 col-8 d-block d-md-none mob-hide-productdetail">
                <div className="product-detail-content">
                  <div className="info-list">
                    <div className="info-item">
                      <b className="me-1">Manufacturer:</b>
                      <span>
                        {Helper.valueIsNotNull(productDetail.value.ManufacturerName) ?
                          productDetail.value.ManufacturerName
                          : ""}
                      </span>
                    </div>
                    <div className="info-item">
                      <b className="me-1">Avnet Manufacturer Part #:</b>
                      <span>
                        {Helper.valueIsNotNull(productDetail.value.ManufacturerPartNumber)
                          ? productDetail.value.ManufacturerPartNumber
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="bs5 row g10 my-2 align-items-center">
                    <div className="col-auto">
                      <div className="info-capsule mt-1">
                        <div className="info-capsule-item">
                          <ProductCompareSelection
                            single_product={productDetail.value}
                            model_ProductCompare_data={compareProductList}
                          />
                        </div>
                        {Helper.valueIsNotNull(productDetail?.value?.DatasheetUrl)
                          && (
                            <a rel="nofollow"
                              href={productDetail?.value?.DatasheetUrl}
                              onClick={() => showDownloadMessage()}
                              target="_blank"
                              className="info-capsule-item">
                              <div className="datasheet_img icon" />
                              <span className="datasheet-label">Datasheet</span>
                            </a>
                          )}

                        {isDesignAvailable && (
                          <a href="#"
                            data-toggle="modal"
                            data-target="#designhubpopup"
                            className="info-capsule-item"                          >
                            <div className="designshub_img icon" />
                            <span className="datasheet-label">Designs</span>
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="col-auto m-b-15 d-flex align-items-center flex-wrap">
                      <Modal3D value={productDetail.value} />
                      <div className="ms-2">
                        <UltraLibrarianModal value={productDetail.value} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <span className="legend-list-item ms-2">
                      <DisplayLifeCycleRisk
                        single_product={productDetail.value}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-7 col-lg-6 col-md-6 mob-show-productdetail">
                <div className="product-detail-content">
                  <div className="info-list">
                    {/* TK - 7978 - adding manufacturer logo on pdp */}

                    {productDetail?.value?.ManufacturerLogo && (
                      <a
                        href={`/${System.siteName()}/manufacturers/m/${productDetail?.value?.ManufacturerName?.toLowerCase()
                          .replace(/\+/g, "and")
                          .replace(/\&/g, "and")
                          .replace(/\./g, "")
                          .replace(/\//g, "-")
                          .replace(/\,/g, "")
                          .replace(/\s/g, "-")
                          .replace(/\---/g, "-")}`}
                      >
                        <img
                          className="my-3"
                          alt={`Official logo for ${productDetail?.value?.ManufacturerName}`}
                          title={`Official logo for ${productDetail?.value?.ManufacturerName}`}
                          style={{ height: "20px" }}
                          src={productDetail?.value?.ManufacturerLogo}
                        />
                      </a>
                    )}

                    <div className="info-item">
                      <b className="me-1">Manufacturer:</b>
                      <a
                        href={`/${System.siteName()}/manufacturers/m/${productDetail?.value?.ManufacturerName?.toLowerCase()
                          .replace(/\+/g, "and")
                          .replace(/\&/g, "and")
                          .replace(/\./g, "")
                          .replace(/\//g, "-")
                          .replace(/\,/g, "")
                          .replace(/\s/g, "-")
                          .replace(/\---/g, "-")}`}
                        className="cursor-pointer text-blue"
                        alt={`Official logo for ${productDetail?.value?.ManufacturerName}`}
                        title={`Official logo for ${productDetail?.value?.ManufacturerName}`}
                      >
                        {productDetail &&
                          Helper.valueIsNotNull(productDetail?.value?.ManufacturerName)
                          ? productDetail.value.ManufacturerName
                          : ""}
                      </a>
                    </div>
                    {productDetail.value.categoryListing && isArray(productDetail.value.categoryListing) &&
                      productDetail.value.categoryListing.length > 0 && (
                        <div className="info-item">
                          <b>Product Category: </b>
                          <span>
                            {productDetail.value.categoryListing.map((v, i) => (
                              // bellow href to redirect to category page is commented and url is being retrieved from the object itself.
                              <a href={`/${speedBoatName}${v.url}`}
                                key={i}                              >
                                {v.value}
                                {i !== productDetail.value.categoryListing.length - 1 ? "," : ""}{" "}
                              </a>
                            ))}
                          </span>
                        </div>
                      )}
                    <div className="info-item">
                      <b className="me-1">Manufacturer Part#: </b>
                      <span>
                        {productDetail?.value?.ERPMFRPartNumber
                          ? productDetail.value.ERPMFRPartNumber : ""}
                      </span>
                    </div>
                    {productDetail?.value?.AliasPartNumberSecondarySupplier &&
                      <div className="info-item">
                        <b className="me-1">Secondary Manufacturer Part#: </b>
                        <span>
                          {productDetail.value.AliasPartNumberSecondarySupplier}
                        </span>
                      </div>
                    }

                    <div className={checkProductTitleMatch(productDetail) ? "info-item d-none" : "info-item"} >
                      <b className="me-1">Also known as: </b>
                      <span>
                        {Helper.valueIsNotNull(productDetail.value.VendorPartNumber)
                          ? productDetail.value.VendorPartNumber
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="bs5 row g10 mt-2 mb-0 align-items-center">
                    <div className="col-auto mb-3 md-sm-0 pe-0">
                      <div className="info-capsule mt-1">
                        <div className="info-capsule-item">
                          <ProductCompareSelection
                            single_product={productDetail.value}
                            model_ProductCompare_data={compareProductList}
                          />
                        </div>
                        {Helper.valueIsNotNull(productDetail?.value?.DatasheetUrl)
                          && (
                            <a rel="nofollow"
                              href={productDetail?.value?.DatasheetUrl}
                              target="_new"
                              onClick={() => showDownloadMessage()}
                              className="info-capsule-item"
                            >
                              <img className="img-fluid" alt="Datasheet" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVHgBnZIxS8NAFMf/KYHgINzSRZCm3yCbY1v8Ck4uVgTnZnPTfgTBRZe4iEO0dHRxctTBLyCJi4OD3qBOwvW99lrS47hc++DPS17e/3cvLwGAgqQsivUzzs5QDoDygdQBnJAQ7hhWrmNSuQogMwwCnhOc6+YDo/5OGpvNDQvg1TgZSZIgz/OOUuqMlNQBBIxxGTBqvXT3n09O+dZngjEsC7OFCbjWJ7DaWkNfAC8vJbVIPGqhc8cFCCtjD7RhoGu8hz5qIsDsT5tDFgsSQiDLMvxuK4SbEW6+Hqb14/ae3GhEcre5UwZB0ONXKLVnabtSSqRpip//P1x+jqaZdVXcia2oyS2H8An67jGZvntPR4p1//FYcA2rBBm6F2+365krkL7NPAEy0HwqftdBcQAAAABJRU5ErkJggg" />
                              <span className="datasheet-label">Datasheet</span>
                            </a>
                          )}

                        {isDesignAvailable && (
                          <a href="#" data-toggle="modal" data-target="#designhubpopup" className="info-capsule-item"
                            onClick={() => {
                              fetchDesignData();
                              setShowDesignHubModal(true);

                              /**
                               * Set Events and Evars as per basav comment (14664)
                               * Author: Devanshi Patel
                               */

                              if (window?.digitalData) {
                                window.digitalData.event.eventinfo.events = "Design Button Click from PDP,PLP";
                              }
                            }}
                          >
                            <div className="designshub_img icon" />
                            <span className="datasheet-label">Designs</span>
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="col-auto m-b-15 d-flex align-items-center flex-wrap">
                      <Modal3D value={productDetail.value} />
                      <div className="ms-2">
                        <UltraLibrarianModal value={productDetail.value} />
                      </div>
                    </div>
                  </div>

                  <div className="legend-list legend-list-horizontal d-flex">
                    <ul>
                      <ProductLegends
                        single_product={productDetail.value}
                        onlyIconTitle={true} />
                    </ul>
                    <span className="legend-list-item">
                      <DisplayLifeCycleRisk
                        single_product={productDetail.value} />
                    </span>
                  </div>
                </div>
              </div>

              {designData && (
                <DesignHubModalPopUp
                  showDesignHubModal={showDesignHubModal}
                  setShowDesignHubModal={setShowDesignHubModal}
                  productDetail={productDetail}
                  designData={designData}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TopProductDetail;
